/**
 * 檔案用途區塊
 * @module api.enum
 * @purpose 定義 API 相關共用列舉，統一描述應用端類型與第三方登入方式常數。
 */
export enum ApplicationType {
  Any = 0,
  Desktop = 1,
  Mobile = 2,
  AppPlatform = 4,
  AppSport = 8,
  AppPlatformSport = 16,
}

/**
 * 宣告內容用途說明與單號關聯
 * @description 應用端類型列舉，使用數值常數標示不同客戶端與平台組合。
 * @purpose 供 API 請求與前後端判斷流程以一致代碼辨識來源應用環境。
 */
export enum ThirdpartyLoginMethod {
  Google = 'GOOGLE',
  Fb = 'FACEBOOK',
  Apple = 'APPLE',
  Zalo = 'ZALO',
  Telegram = 'TELEGRAM',
  WalletConnect = 'WALLETCONNECT',
  Passkey = 'PASSKEY',
}

/**
 * 宣告內容用途說明與單號關聯
 * @description 第三方登入方式列舉，定義支援的外部身分驗證供應商識別字串。
 * @purpose 統一登入流程中的 provider 參數與驗證分流依據，避免魔法字串散落。
 */

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:21:43.068Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotation layout with top, declaration, and bottom blocks; preserved runtime logic; omitted @external in declaration blocks because no declaration origin tickets were provided.
 */
